import { useState, useEffect } from 'react';

import { hasWindow } from '@pb/helpers';
import { TDevice } from './use-is-device.types';

function checkDevice(device: string): boolean | undefined {
    switch (device) {
        case 'mobile':
            return window.innerWidth < 768;
        case 'tabletPortrait':
            return window.innerWidth >= 768 && window.innerWidth < 992;
        case 'tabletLandscape':
            return window.innerWidth >= 992 && window.innerWidth < 1200;
        case 'desktop':
            return window.innerWidth >= 1200;
    }
}

export function useIsDevice(device: TDevice): boolean {
    const [isDevice, setIsDevice] = useState<boolean>(undefined as any);

    useEffect(() => {
        if (!hasWindow()) {
            return undefined;
        }

        function checkSetIsMobile() {
            setIsDevice(checkDevice(device) as boolean);
        }

        checkSetIsMobile();

        window.addEventListener('resize', checkSetIsMobile);

        return () => {
            window.removeEventListener('resize', checkSetIsMobile);
        };
    }, [device]);

    return isDevice;
}
